import { render, staticRenderFns } from "./CreatedDeals.vue?vue&type=template&id=a29288a6&scoped=true&"
import script from "./CreatedDeals.vue?vue&type=script&lang=js&"
export * from "./CreatedDeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29288a6",
  null
  
)

export default component.exports